export const DISPO_RE = /disposizion|\bdispo\b/i;
export const isDispoType = (t) => DISPO_RE.test(t || "");
export const isDispo = (b) => !!b && isDispoType(b.service_type);

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("it-IT", { timeZone: "Europe/Rome", hour: "2-digit", minute: "2-digit" }) : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");
export const fmtDur = (min) => {
  if (min == null) return "—";
  const h = Math.floor(min / 60), m = min % 60;
  return `${h} ${h === 1 ? "ora" : "ore"} e ${m} min`;
};
export const fmtClock = (sec) => {
  const s = Math.max(0, Math.floor(sec));
  return [Math.floor(s / 3600), Math.floor((s % 3600) / 60), s % 60].map((x) => String(x).padStart(2, "0")).join(":");
};
const ROME_TZ = "Europe/Rome";
const romeParts = (d) => Object.fromEntries(new Intl.DateTimeFormat("en-GB", { timeZone: ROME_TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
  .formatToParts(d).filter((p) => p.type !== "literal").map((p) => [p.type, p.value]));
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const p = romeParts(new Date(iso));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
};
// Interpreta "YYYY-MM-DDTHH:MM" come ora di Roma, indipendentemente dal fuso del browser
export const romeInputToIso = (v) => {
  if (!v) return null;
  const guess = Date.parse(`${v}:00Z`);
  const p = romeParts(new Date(guess));
  const offset = Date.parse(`${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}:00Z`) - guess;
  return new Date(guess - offset).toISOString();
};
